import React from 'react';
import {Link, Links} from "react-router-dom";

const Header = () => {
    return (
        <nav>
            <Link to="/"> Home </Link>
            <Link to="/Achievements"> Achievements </Link>
            {/* <Link to="/Blog"> Blog </Link> */}
            <Link to="/About"> About </Link>
            <Link to="/UseCases"> Use Cases </Link>
            <Link to="/Contact"> Contact </Link>
        </nav>
    )
};

export default Header;